import { createClient, type SupabaseClient } from "@supabase/supabase-js";

// Env vars are set on the Cloudflare Pages project (production +
// preview) via the Cloudflare dashboard. Locally, drop them in
// frontend/.env.local. When either is missing, the app falls back to
// the stub session — that's the dev mode through Sprint 5.

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase: SupabaseClient | null =
  url && anonKey ? createClient(url, anonKey) : null;

export const isSupabaseEnabled = supabase !== null;
